import React from "react";
import OverlayContainer from "../OverlayContainer";
import { withRouter, useParams } from "react-router";
import axiosInstance from "../../../axios";
import { CourseBuilderStaticData } from "../../../_constants/staticData";
const SaveDraft = ({ history, handleClose, formValues, Submit, current }) => {
  let { id } = useParams();

  const handleSaveCourse = (courseId) => {
    const payload = {
      courseType: formValues.courseType,
      liveWebinarCourse: formValues.liveWebinarCourse,
      courseName: formValues.courseName,
      category: formValues.category,
      subCategory: formValues.subCategory,
      IsAdult: formValues.IsAdult,
      goals: formValues.goals?.length > 1 ? formValues?.goals : [],
      courseOneLiner: formValues.courseOneLiner,
      courseOutDescription: formValues.courseOutDescription,
      preRequisites:
        formValues.preRequisites?.length > 1 ? formValues?.preRequisites : [],

      description:
        formValues.description !== null ? formValues.description : "",
      faqs: formValues.faqs?.length > 1 ? formValues.faqs : [],
      syllabus: formValues.syllabus?.length > 1 ? formValues?.syllabus : [],
      level: formValues.level,
      language: formValues.language,
      duration: formValues.duration,
      imageFiles: formValues.imageFiles,
      videoFiles: formValues.videoFiles,
      scheduleEvent: formValues.scheduleEvent,
      courseSections:
        formValues.courseSections?.length > 1 ? formValues?.courseSections : [],
      isFree: formValues.isFree,
      currency: "USD $",
      enrollmentFee: formValues.enrollmentFee,
      promotionalOffer: formValues.promotionalOffer,
      promotionalCode: formValues.promotionalCode,
      discountPercent: formValues.discountPercent,
      status: formValues.status,
    };
    axiosInstance.put(`/course/${courseId}`, payload).then(() => {
      history.push("/dashboard/courses");
    });
  };

  const handleCancel = (courseId) => {
    axiosInstance.post("course/delete", { courseId: courseId }).then(() => {
      history.push("/dashboard");
    });
  };

  return (
    <OverlayContainer>
      <div className="alert-dialog-inner">
        <div className="alert-dialog-close" onClick={handleClose}>
          <div>
            <i className="icon check"></i>
          </div>
        </div>
        <div className="alert-title">Warning!</div>
        <div className="alert-message">
          {CourseBuilderStaticData.saveDraftOverlay.header}
        </div>

        <div className="alert-close-btn">
          <a
            className={current < 8 ? "course-disable" : ""}
            onClick={() => handleSaveCourse(id)}
          >
            SAVE
          </a>

          <a className="btn-cancel" onClick={() => handleCancel(id)}>
            CANCEL
          </a>
        </div>
      </div>
    </OverlayContainer>
  );
};

export const SaveDraftOverlay = withRouter(SaveDraft);
